import { Component } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { Subject } from 'rxjs';

export interface DadosBancariosConfirmacao {
  banco: string;
  tipoConta: string;
  agencia: string;
  digitoAgencia?: string;
  conta: string;
  digitoConta: string;
}

export interface RepresentanteConfirmacao {
  nome: string;
  cpf: string;
  emailPj: string;
}

export interface DadosEmpresaConfirmacao {
  cnpj: string;
  nomeEmpresa: string;
}

@Component({
  selector: 'app-modal-confirmar-solicitacao',
  templateUrl: './modal-confirmar-solicitacao.component.html',
  styleUrls: ['./modal-confirmar-solicitacao.component.scss'],
})
export class ModalConfirmarSolicitacaoComponent {
  confirmado: Subject<boolean> = new Subject();

  dadosEmpresa: DadosEmpresaConfirmacao = { cnpj: '', nomeEmpresa: '' };
  representantes: RepresentanteConfirmacao[] = [];
  dadosBancarios: DadosBancariosConfirmacao = {
    banco: '',
    tipoConta: '',
    agencia: '',
    conta: '',
    digitoConta: '',
  };

  visivel: 'info' | 'mais' = 'info';

  constructor(public modalRef: MDBModalRef) {}

  get cnpjFormatado(): string {
    return this.dadosEmpresa.cnpj?.replace(
      /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
      '$1.$2.$3/$4-$5'
    ) ?? '';
  }

  formatarCpf(cpf: string): string {
    return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') ?? '';
  }

  confirmar(): void {
    this.confirmado.next(true);
    this.modalRef.hide();
  }

  cancelar(): void {
    this.confirmado.next(false);
    this.modalRef.hide();
  }
}
